module.exports = __webpack_public_path__ + "img/str150.31cda2e6.png";